import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Toolbar, Card, CardContent, Button } from "@mui/material";
import moment from "moment";
import { fetchEventAlerts, updateEventAlert } from "../../actions";
import { communicator_event_types } from "../common/selectable_data";

const eventWidth = 200;

const AlertCard = (props) => {
  const dispatch = useDispatch();
  // console.log("props", props);

  const handleEventState = useCallback(
    (id) => {
      const alert = {
        status: true,
      };
      dispatch(updateEventAlert({ alert, id }));
    },
    [dispatch]
  );

  return (
    <Card sx={{ mr: 3, mt: 3, mb: 3 }}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <CardContent>
          <Box
            compoment="div"
            sx={{
              display: "flex",
              justifyContent: "center",
              borderRadius: "25px",
              background: "#E83D45",
              textAlign: "center",
              fontSize: "1.3rem",
              color: "white",
              pt: "2px",
              fontWeight: "bold",
            }}
          >
            <div>
              {
                communicator_event_types.find((type) => type.id === props.type)
                  .label
              }
            </div>
          </Box>
          <Box sx={{ mt: 2, mb: 2, textAlign: "center" }}>
            {props.Worker.Application.name}
            <br /> {props.Worker.name}
            <br /> {props.Worker.phone}
            <br />
            <Box component="span" sx={{ fontSize: "0.8rem" }}>
              {moment(props.createdAt).format("YYYY-MM-DD HH:mm:ss")}
            </Box>
          </Box>
          <Button
            variant="contained"
            fullWidth={true}
            onClick={() => handleEventState(props.id)}
          >
            확인
          </Button>
        </CardContent>
      </Box>
    </Card>
  );
};

const AlertEvent = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { rows } = useSelector((state) => state.event.alerts);

  useEffect(() => {
    if (user) {
      dispatch(fetchEventAlerts());
    }
  }, [dispatch, user]);

  return (
    <Box
      component="div"
      sx={{ width: { sm: eventWidth }, flexShrink: { sm: 0 } }}
    >
      <Toolbar />
      {rows.map((alert) => (
        <AlertCard key={alert.id} {...alert} />
      ))}
    </Box>
  );
};

export default AlertEvent;
